const initialState = {
  account: {
    isLoading: true,
    connected: false
  }
}

const startAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: true
  }
})

const accountLoaded = (state, {
  email,
  access_granted: accessGranted,
  display_connect_toggle: displayConnectToggle,
  connected
}) => ({
  ...state,
  account: {
    ...state.account,
    email,
    accessGranted,
    displayConnectToggle,
    connected
  }
})

const stopAccountLoading = (state) => ({
  ...state,
  account: {
    ...state.account,
    isLoading: false
  }
})

const disconnectAccount = (state) => ({
  ...state,
  account: {
    ...state.account,
    connected: false
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'STRIPE_FETCH_ACCOUNT':
      return startAccountLoading(state)
    case 'STRIPE_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    case 'STRIPE_FETCH_ACCOUNT_COMPLETE':
      return stopAccountLoading(state)
    case 'STRIPE_DISCONNECT_ACCOUNT':
      return disconnectAccount(state)
    default:
      return state
  }
}
